/**
 *
 * Deep clones an object by serializing and deserializing it using
 * JSON.stringify() and JSON.parse() with custom replacer and reviver functions.
 *
 * - Persists "undefined" values.
 * - Persists Date (date-fns TZDate) objects.
 *
 * @param object
 * @returns cloned object
 */
export function deepClone<T>(object: T): T {
    return parseWithReviver(stringifyWithReplacer(object));
}
